const IMPORTS_CHZ = ['imports-chz/new'];
export default IMPORTS_CHZ;
